import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import SearchBar from "./SearchBar";
import { pluralizeCount } from "../../helpers/housingAssignment";

interface ManageBedsButtonState {
  open: boolean;
  bedCount: number;
  onToggle: any;
}

// The toggle lives beside a room's other actions, so it ships separately from the panel itself.
export const ManageBedsButton = ({ open, bedCount, onToggle }: ManageBedsButtonState) => (
  <Button size="sm" className={open ? "app-primary-color button" : "app-primary-color-inverse button"} onClick={onToggle}>
    {open ? "Hide Beds" : `Manage ${pluralizeCount(bedCount, "Bed")}`}
  </Button>
);

interface RoomBedsPanelState {
  beds: any[];
  search: string;
  setSearch: any;
  placeholder?: string;
  showSearch?: boolean;
  renderBed: (bed: any) => React.ReactNode;
  renderBefore?: (bed: any) => React.ReactNode;
}

// A room's beds, expanded in place: its own search over bed names and occupants, then the beds
// two-up. Shared by the Shelter room rows and the case housing flow's inventory.
const RoomBedsPanel = ({
  beds,
  search,
  setSearch,
  placeholder = "Search beds or people",
  showSearch = true,
  renderBed,
  renderBefore,
}: RoomBedsPanelState) => {
  const q = search.trim().toLowerCase();
  const visible = beds.filter((b: any) => {
    if (!q) return true;
    const occupant = `${b.firstname || ""} ${b.lastname || ""}`.toLowerCase();
    return b.name.toLowerCase().includes(q) || occupant.includes(q);
  });

  return (
    <>
      {showSearch && (
        <div className="mt-3">
          <SearchBar cssClass="" placeholder={placeholder} searchText={search} setSearchText={setSearch} searchLogic={() => {}} />
        </div>
      )}
      <Row className="g-2 mt-1">
        {visible.length === 0 ? (
          <Col xs={12}>
            <p className="text-muted small mb-0">No beds match this search.</p>
          </Col>
        ) : (
          visible.map((bed: any) => (
            <React.Fragment key={bed.id}>
              {renderBefore && renderBefore(bed)}
              <Col xs={12} md={6}>
                {renderBed(bed)}
              </Col>
            </React.Fragment>
          ))
        )}
      </Row>
    </>
  );
};

export default RoomBedsPanel;
